import { useLocation } from 'react-router-dom';
import getDevice from '~/libs/deviceDetector';
import useUIContext from '~/ui/use-ui-context';
import useCasinoLocation from '~/hooks/use-casino-location';
import { Bigger, Smaller } from '~/components/layout/mediaquery';
import { CASINO_SEARCH_PATHS, LIVE_CASINO_SEARCH_PATHS } from '~/components/router/casino-routes';
import Search from '~/components/search/search-container';
import { FiltersContainer } from './navbar.styles';
import CasinoSubNavigation from '~/components/casino-shared/subnavigation/subnavigation';

const isTablet = getDevice() === 'Tablet';

const NavBar = () => {
	const location = useLocation();
	const activeSearch = [...CASINO_SEARCH_PATHS, ...LIVE_CASINO_SEARCH_PATHS].some(path =>
		location.pathname.includes(path)
	);
	const { hasStaticHeader } = useUIContext();
	const { isLiveCasinoLocation } = useCasinoLocation();
	const containerDataAt = isLiveCasinoLocation ? 'live-casino-nav-bar' : 'casino-nav-bar';
	const filtersDataAt = isLiveCasinoLocation ? 'live-casino-filter-casino-nav-bar' : 'casino-filter-casino-nav-bar';

	return (
		<FiltersContainer data-at={containerDataAt} secondary hasStaticHeader={hasStaticHeader} isTablet={isTablet}>
			<Bigger>
				{!activeSearch && <CasinoSubNavigation isLive={isLiveCasinoLocation} filtersDataAt={filtersDataAt} />}
				<Search />
			</Bigger>
			<Smaller>
				<CasinoSubNavigation isLive={isLiveCasinoLocation} filtersDataAt={filtersDataAt} />
			</Smaller>
		</FiltersContainer>
	);
};

export default NavBar;
